<template>
  <div>
    <div class="tap-top4" @click="toggleChatPopup">
      <img class="chatbot-logo" src="img/chatbotlogo.svg" alt="chatbotLogo" />
    </div>
    <!-- Chatbot Popup -->
    <div v-if="showChatPopup" class="chat-popup" :class="{ closing: isClosing }">
      <div class="chat-header">
        <div class="chat-title">
          <img class="chatbot-logo-small" src="img/chatbotlogo.svg" alt="chatbotLogo" />
          <span>Chatbot</span>
        </div>
        <div class="close-button" @click="toggleChatPopup">
          <b-icon icon="x-circle-fill"></b-icon>
        </div>
      </div>
      <!-- Chat Messages -->
      <div class="chat-messages" ref="chatMessages">
        <div v-for="message in messages" :key="message.id" class="message" :class="message.sender">
          <div class="img">
            <img class="avatar" :src="message.sender === 'bot' ? 'img/chatbotlogo.svg' : userImage
              " alt="avatar" />
          </div>
          <div class="bubble">
            <!-- Account Details -->
            <template v-if="message.accountDetailData">
              <div class="account-detail-container">
                <h4>Account Details</h4>
                <p v-if="message.accountDetailMessage">
                  {{ message.accountDetailMessage }}
                </p>
                <ul>
                  <li>
                    <strong>Name:</strong>
                    {{ message.accountDetailData.name.first }}
                    {{ message.accountDetailData.name.last }}
                  </li>
                  <li>
                    <strong>Email:</strong>
                    {{ message.accountDetailData.authentication.email }}
                  </li>
                  <li>
                    <strong>Phone:</strong>
                    {{ message.accountDetailData.authentication.phone }}
                  </li>
                  <!-- <li>
                    <strong>UserName:</strong>
                    {{ message.accountDetailData.authentication.userName }}
                  </li> -->
                  <li>
                    <strong>Category:</strong>
                    {{ message.accountDetailData.category }}
                  </li>
                  <!-- <li>
                    <strong>Status:</strong>
                    {{
                      message.accountDetailData.isActive ? "Active" : "Inactive"
                    }}
                  </li> -->
                  <li v-if="message.accountDetailData.addresses?.length">
                    <strong>Addresses:</strong>
                    <ul>
                      <li v-for="address in message.accountDetailData.addresses" :key="address._id">
                        {{ address.city }}, {{ address.state }},
                        {{ address.street1 }}, {{ address.street2 }},
                        {{ address.zip }}
                      </li>
                    </ul>
                  </li>
                </ul>
              </div>
            </template>

            <!-- Order Table -->
            <template v-if="message.orderTableData">
              <div class="order-table-container">
                <h4>{{ message.orderTableTitle }}</h4>
                <p v-if="message.orderTableMessage">
                  {{ message.orderTableMessage }}
                </p>
                <table class="order-table">
                  <thead>
                    <tr>
                      <th>Item Name</th>
                      <th>Price</th>
                      <th>Status</th>
                      <th>Order Id</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="item in message.orderTableData" :key="item._id"
                      @click="handleOrderRowClick(item, message.scenarioType)" class="order-row">
                      <td>{{ item.name }}</td>
                      <td>{{ currency.symbol }}{{ item.price }}</td>
                      <td>{{ item.orderStatus }}</td>
                      <td>{{ item.orderId.toString().substring(0, 5) }}...</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </template>

            <!-- Payment Issue Contact Form -->
            <!-- <template v-if="selectedPaymentIssueOrder"> -->
            <template v-if="message.paymentIssueForm">
              <div class="contact-form-container">
                <form @submit.prevent="submitPaymentIssueForm">
                  <div>
                    <label>Message/Query:</label>
                    <textarea v-model="paymentIssueForm.message" required></textarea>
                  </div>
                  <button type="submit">Submit</button>
                </form>
              </div>
            </template>

            <!-- Order Not Found -->
            <template v-if="message.orderNotFoundForm">
              <div class="contact-form-container">
                <form @submit.prevent="submitOrderNotFoundForm">
                  <div>
                    <label>Message/Query:</label>
                    <textarea v-model="paymentIssueForm.message" required></textarea>
                  </div>
                  <button type="submit">Submit</button>
                </form>
              </div>
            </template>
            <!-- Report Form -->
            <template v-if="message.reportIssueForm">
              <div class="bot-message contact-form-container">
                <form @submit.prevent="submitReportIssueForm">
                  <div>
                    <label>Message/Query:</label>
                    <textarea v-model="reportIssueForm.message" required></textarea>
                  </div>
                  <button type="submit">Submit</button>
                </form>
              </div>
            </template>

            <!-- Delivary Form -->
            <template v-if="message.delivaryIssueForm">
              <div class="bot-message contact-form-container">
                <form @submit.prevent="submitDelivaryIssueForm">
                  <div>
                    <label>Message/Query:</label>
                    <textarea v-model="delivaryIssueForm.message" required></textarea>
                  </div>
                  <button type="submit">Submit</button>
                </form>
              </div>
            </template>

            <!-- Order Details -->
            <template v-if="message.orderDetailData">
              <div class="order-detail-container">
                <h4>{{ message.orderDetailTitle }}</h4>
                <p v-if="message.orderDetailMessage">
                  {{ message.orderDetailMessage }}
                </p>
                <ul>
                  <li>
                    <strong>Order ID:</strong>
                    {{ message.orderDetailData.orderId }}
                  </li>
                  <li>
                    <strong>Item Name:</strong>
                    <span v-if="message.orderDetailData.items?.[0]">
                      {{ message.orderDetailData.items[0].name }}
                    </span>
                  </li>
                  <li>
                    <strong>Provider:</strong>
                    <span v-if="message.orderDetailData.items?.[0]">
                      {{ message.orderDetailData.items[0].providerName }}
                    </span>
                  </li>
                  <li>
                    <strong>Price:</strong>
                    <span v-if="message.orderDetailData.items?.[0]">
                      {{ currency.symbol
                      }}{{ message.orderDetailData.items[0].price }}
                    </span>
                  </li>
                  <li v-if="message.orderDetailData.orderStatus">
                    <strong>Order Status:</strong>
                    {{ message.orderDetailData.orderStatus }}
                  </li>
                  <li>
                    <strong>Payment Type:</strong>
                    {{ message.orderDetailData.paymentType }}
                  </li>
                  <!-- If NOT self-pickup, show the delivery address -->
                  <li v-if="
                    message.orderDetailData.items[0].delivery
                      ?.courier_name !== 'self' &&
                    message.orderDetailData.deliveryAddress
                  ">
                    <strong>Delivery Address:</strong>
                    {{
                      message.orderDetailData.deliveryAddress.address
                        ?.houseNumber
                    }},
                    {{
                      message.orderDetailData.deliveryAddress.address?.street1
                    }},
                    <template v-if="
                      message.orderDetailData.deliveryAddress.address?.street2
                    ">
                      {{
                        message.orderDetailData.deliveryAddress.address.street2
                      }},
                    </template>
                    {{ message.orderDetailData.deliveryAddress.address?.city }},
                    {{
                      message.orderDetailData.deliveryAddress.address?.state
                    }},
                    {{ message.orderDetailData.deliveryAddress.address?.zip }}
                  </li>
                  <li v-else-if="
                    message.orderDetailData.items[0].delivery
                      ?.courier_name === 'self'
                  ">
                    <strong>Delivery Address:</strong> This is a self-pickup
                    order.
                  </li>

                  <li v-if="message.orderDetailData.items?.[0]?.imageLink">
                    <img :src="message.orderDetailData.items[0].imageLink" alt="Product" class="product-image" />
                  </li>
                </ul>
              </div>
            </template>

            <!-- Contact Form -->
            <template v-if="message.contactForm">
              <div class="contact-form-container">
                <form @submit.prevent="submitContactForm">
                  <div>
                    <label>Message/Query:</label>
                    <textarea v-model="contactForm.message" required></textarea>
                  </div>
                  <button type="submit">Submit</button>
                </form>
              </div>
            </template>
            <div class="msg" v-html="getHtml(message.text)"></div>
            <!-- Buttons -->
            <div v-if="message.buttons?.length" class="button-list">
              <button v-for="button in message.buttons" :key="button.payload" @click="handleButtonClick(button.payload)"
                class="response-button">
                {{ button.title }}
              </button>
            </div>
          </div>
          <!-- <span class="timestamp">{{ message.time }}</span> -->
        </div>
        <!-- Typing Indicator -->
        <div v-if="isTyping" class="message bot">
          <div class="bubble typing-indicator">
            <div class="dot"></div>
            <div class="dot"></div>
            <div class="dot"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      showChatPopup: false,
      isClosing: false,
      hasOpened: false,
      isTyping: false,
      optionButtons: [],
      currentOptionName: "",
      contactForm: { message: "" },
      previousOptionName: "",
      rootMessages: [],
      rootNextParents: [],
      selectedPaymentIssueOrder: null,
      selectedReportIssueItem: null,
      selectedDelivaryIssueItem: null,
      paymentIssueForm: { message: "" },
      reportIssueForm: { message: "" },
      delivaryIssueForm: { message: "" },
      orderNotFoundMode: false,
      selectedOrderId: null,
    };
  },
  async mounted() {
    await this.$store.dispatch("profile/getCustomerData", this.userInfo._id);
    await this.$store.dispatch("profile/fetchOrderList");
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.auth.userInfo,
      messages: (state) => state.chatbot.messages,
      userData: (state) => state.profile.userData,
      currency: (state) => state.home.currency,
      isLoggedin: (state) => state.auth.isLoggedin,
      orderList: (state) => state.profile.orderList,
    }),
    userImage() {
      return this.userData?.extendedAttributes?.profilePhoto || "img/hero.png";
    },
  },
  watch: {
    messages() {
      this.$nextTick(() => {
        const chatMessages = this.$refs.chatMessages;
        if (chatMessages) {
          chatMessages.scrollTop = chatMessages.scrollHeight;
        }
      });
    },
  },
  methods: {
    getHtml(content) {
      if (typeof content === "string") return content;
      return content?.map((el) => `<p>${el.orderMessage}</p>`).join("") || "";
    },
    async toggleChatPopup() {
      if (this.showChatPopup) {
        this.isClosing = true;
        setTimeout(() => {
          this.showChatPopup = false;
          this.isClosing = false;
        }, 600);
      } else {
        this.showChatPopup = true;
        if (!this.hasOpened) {
          await this.addWelcomeMessageWithTyping();
          this.hasOpened = true;
        }
      }
    },
    async fetchRootOptions(
      option_name = "root",
      option_type = "option_based",
      extraParams = {},
    ) {
      this.isTyping = true;

      const token = localStorage.getItem(
        `${process.env.VUE_APP_TENANT}:access_token`,
      );

      const metadata = {
        type: "fastforge_chat_option_based",
        loginUrl: window.location.origin,
        option_type,
        option_name,
        authorization: token,
        ...extraParams,
      };

      const payload = {
        sender: this.userInfo?._id || "683fd5b24850fae097f99d37",
        metadata,
        message: "",
      };

      try {
        const response = await this.$store.dispatch(
          "chatbot/fetchOptionsAction",
          payload,
        );

        const data = await response.data;
        const custom = data[0]?.custom || {};
        const options = custom.options || [];

        if (option_name === "root" && Array.isArray(options)) {
          this.rootMessages = [];
          this.rootNextParents = [];

          options.forEach((opt) => {
            this.rootMessages.push(opt.message);
            this.rootNextParents.push(opt.nextParent);
          });
        }

        if (option_name !== "root" && this.rootNextParents?.length) {
          const index = this.rootNextParents.indexOf(option_name);
          if (index !== -1) {
            this.previousOptionName = this.rootMessages[index];
          }
        }

        if (option_name === "contact_us" && option_type === "api_based") {
          this.addContactFormMessage(
            custom.message || "Please fill out the form below to contact us",
            options,
            option_name,
          );
        } else if (
          option_name === "view_account_details" &&
          option_type === "api_based" &&
          custom.user
        ) {
          this.addAccountDetailMessage(
            custom.message || "Here is your account details:",
            custom.user,
            options,
          );
        } else if (
          option_name === "view_order" &&
          option_type === "api_based" &&
          custom.order
        ) {
          this.addOrderDetailMessage(
            custom.title || "Order Details",
            custom.message || "",
            custom.order,
            options,
          );
        } else if (
          [
            "track_order",
            "cancel_my_order",
            "pending_payment_list",
            "report_issue",
            "report_delivary_issue",
            "report_issue_for_unable_to_cancel_order",
          ].includes(option_name) &&
          option_type === "api_based" &&
          Array.isArray(custom.items)
        ) {
          this.addOrderTableMessage(
            custom.title || "Your Orders",
            custom.message || "",
            custom.items,
            options,
          );
        } else if (
          option_name === "payment_issues" &&
          option_type === "api_based" &&
          Array.isArray(custom.items)
        ) {
          this.addOrderTableMessage(
            custom.title || "Select an order with payment issues",
            custom.message || "",
            custom.items,
            options,
            "payment_issues",
          );
          this.isTyping = false;
          return;
        } else if (
          option_name === "order_not_found" &&
          option_type === "api_based"
        ) {
          this.orderNotFoundMode = true;
          this.selectedPaymentIssueOrder = null;
          this.paymentIssueForm = { message: "" };
          this.isTyping = false;
          this.addOrderNotFoundFormMessage("Please describe your issue below:");
          return;
        } else if (
          option_name === "my_order_issue" &&
          option_type === "api_based"
        ) {
          this.reportIssueMode = true;
          this.selectedReportIssueItem = null;
          this.reportIssueForm = { message: "" };
          this.isTyping = false;
          this.addReportIssueFormMessage(
            "Please provide details about the issue you want to report:",
          );
          return;
        } else if (
          option_name === "order_delivary_issue" &&
          option_type === "api_based"
        ) {
          this.reportDelivaryMode = true;
          this.selectedDelivaryIssueItem = null;
          this.delivaryIssueForm = { message: "" };
          this.isTyping = false;
          this.addReportIssueFormMessage(
            "Please provide details about the issue you want to report:",
          );
          return;
        } else {
          this.optionButtons = options;
          this.addMessage(
            custom.message || data[0]?.text || "Please choose an option:",
            "bot",
            options.map((opt) => ({
              title: opt.message,
              payload: JSON.stringify({
                optionType: opt.nextParent,
                nextParent: opt.optionType,
                url: opt.url,
              }),
            })),
          );
        }
      } catch {
        this.addMessage("Sorry, something went wrong.", "bot");
      }

      this.isTyping = false;
    },
    addAccountDetailMessage(message, user, options) {
      this.messages.push({
        id: this.messages.length + 1,
        text: "",
        accountDetailMessage: message,
        accountDetailData: user,
        time: this._getTime(),
        sender: "bot",
        buttons:
          options?.map((opt) => ({
            title: opt.message,
            payload: JSON.stringify({
              optionType: opt.nextParent,
              nextParent: opt.optionType,
            }),
          })) || [],
      });
    },
    addContactFormMessage(
      messageText = "Please fill out the form below to contact us",
      options = [],
      option_name = "contact_us",
    ) {
      this.messages.push({
        id: this.messages.length + 1,
        text: messageText,
        contactForm: true,
        option_name,
        time: this._getTime(),
        sender: "bot",
        buttons: options.map((opt) => ({
          title: opt.message,
          payload: JSON.stringify({
            optionType: opt.nextParent,
            nextParent: opt.optionType,
            url: opt.url,
          }),
        })),
      });
    },
    addOrderTableMessage(title, message, items, options, scenarioType = "") {
      this.messages.push({
        id: this.messages.length + 1,
        text: "",
        orderTableTitle: title,
        orderTableMessage: message,
        orderTableData: items.map((order) => ({
          ...order,
          ...((order.items && order.items[0]) || {}),
        })),
        time: this._getTime(),
        sender: "bot",
        buttons:
          options?.map((opt) => ({
            title: opt.message,
            payload: JSON.stringify({
              optionType: opt.nextParent,
              nextParent: opt.optionType,
            }),
          })) || [],
        scenarioType,
      });
    },
    addOrderDetailMessage(title, message, order, options) {
      this.messages.push({
        id: this.messages.length + 1,
        text: "",
        orderDetailTitle: title,
        orderDetailMessage: message,
        orderDetailData: order,
        time: this._getTime(),
        sender: "bot",
        buttons:
          options?.map((opt) => ({
            title: opt.message,
            payload: JSON.stringify({
              optionType: opt.nextParent,
              nextParent: opt.optionType,
            }),
          })) || [],
      });
    },
    addMessage(text, sender, buttons = []) {
      this.messages.push({
        id: this.messages.length + 1,
        text,
        time: this._getTime(),
        sender,
        buttons,
      });
    },
    async handleButtonClick(payload) {
      let parsed = {};
      try {
        parsed = JSON.parse(payload);
      } catch {
        console.error("Invalid payload format:", payload);
        return;
      }
      if (parsed.nextParent === "external_link" && parsed.url) {
        window.open(parsed.url, "_blank");
        return;
      }
      if (parsed.optionType && parsed.nextParent) {
        await this.fetchRootOptions(parsed.optionType, parsed.nextParent);
      }
    },
    sellerDetail(state) {
      let sellerData = [];
      if (
        Array.isArray(state.profile.orderList) &&
        state.profile.orderList.length > 0
      ) {
        state.profile.orderList.filter((obj) => {
          obj.orderId === this.orderNumber;
          {
            let arrObj = {
              id: obj.items[0]?.delivery?.deliveryOwner?._id || "",
              name: obj.items[0]?.delivery?.deliveryOwner?.name || "",
              email: obj.items[0]?.delivery?.deliveryOwner?.email || "",
              category: obj.items[0]?.delivery?.deliveryOwner?.category || "",
              phone: obj.items[0]?.delivery?.deliveryOwner?.phone || "",
            };
            sellerData.push(arrObj);
          }
        });
        return sellerData;
      } else {
        this.isloading = false;
        return [];
      }
    },
    async submitPaymentIssueForm() {
      const token = localStorage.getItem(
        `${process.env.VUE_APP_TENANT}:access_token`,
      );
      this.sellerDetails = this.sellerDetail(this.$store.state);
      const name =
        `${this.userInfo.name?.first || ""} ${this.userInfo.name?.last || ""}`.trim();
      const email = this.userInfo.authentication.email;
      const phone = this.userInfo.authentication.phone;
      const description = this.paymentIssueForm.message;
      const payload = {
        sender: this.userInfo?._id || "683fd5b24850fae097f99d37",
        metadata: {
          type: "fastforge_chat_option_based",
          project_name: "fastforge",
          option_type: "api_based",
          option_name: "my_payment_issue",
          order_id: this.selectedOrderId,
          reportedToId: this.sellerDetails[0].id,
          assignToId: this.sellerDetails[0].id,
          loginUrl: window.location.origin,
          name,
          email,
          phone,
          description,
          subject: "Payment Issues",
          authorization: token,
        },
        message: "",
      };
      try {
        const response = await this.$store.dispatch(
          "chatbot/fetchOptionsAction",
          payload,
        );
        const data = await response.data;
        const msg = data[0]?.custom?.message || "Thank you for contacting us!";
        const options = data[0]?.custom?.options || [];
        const formattedMsg = msg.replace(
          /\[([^\]]+)\]\(([^)]+)\)/g,
          '<a href="$2" target="_blank" rel="noopener noreferrer">$1</a>',
        );

        this.addMessage(
          formattedMsg,
          // msg,
          "bot",
          options.map((opt) => ({
            title: opt.message,
            payload: JSON.stringify({
              optionType: opt.nextParent,
              nextParent: opt.optionType,
              url: opt.url,
            }),
          })),
        );
        this.contactForm = { message: "" };
      } catch {
        this.addMessage(
          "Sorry, there was a problem submitting your request.",
          "bot",
        );
      }
    },
    async submitReportIssueForm() {
      const token = localStorage.getItem(
        `${process.env.VUE_APP_TENANT}:access_token`,
      );
      this.sellerDetails = this.sellerDetail(this.$store.state);
      const name =
        `${this.userInfo.name?.first || ""} ${this.userInfo.name?.last || ""}`.trim();
      const email = this.userInfo.authentication.email;
      const phone = this.userInfo.authentication.phone;
      const description = this.reportIssueForm.message;
      const payload = {
        sender: this.userInfo?._id || "683fd5b24850fae097f99d37",
        metadata: {
          type: "fastforge_chat_option_based",
          project_name: "fastforge",
          option_type: "api_based",
          option_name: "order_delivary_issue",
          order_id: this.selectedOrderId,
          reportedToId: this.sellerDetails[0].id,
          assignToId: this.sellerDetails[0].id,
          loginUrl: window.location.origin,
          name,
          email,
          phone,
          description,
          subject: "Delivery Issues",
          authorization: token,
        },
        message: "",
      };
      try {
        const response = await this.$store.dispatch(
          "chatbot/fetchOptionsAction",
          payload,
        );
        const data = await response.data;
        const msg = data[0]?.custom?.message || "Thank you for contacting us!";
        const options = data[0]?.custom?.options || [];
        const formattedMsg = msg.replace(
          /\[([^\]]+)\]\(([^)]+)\)/g,
          '<a href="$2" target="_blank" rel="noopener noreferrer">$1</a>',
        );

        this.addMessage(
          formattedMsg,
          // msg,
          "bot",
          options.map((opt) => ({
            title: opt.message,
            payload: JSON.stringify({
              optionType: opt.nextParent,
              nextParent: opt.optionType,
              url: opt.url,
            }),
          })),
        );
        this.contactForm = { message: "" };
      } catch {
        this.addMessage(
          "Sorry, there was a problem submitting your request.",
          "bot",
        );
      }
    },
    async submitDelivaryIssueForm() {
      const token = localStorage.getItem(
        `${process.env.VUE_APP_TENANT}:access_token`,
      );
      this.sellerDetails = this.sellerDetail(this.$store.state);
      const name =
        `${this.userInfo.name?.first || ""} ${this.userInfo.name?.last || ""}`.trim();
      const email = this.userInfo.authentication.email;
      const phone = this.userInfo.authentication.phone;
      const description = this.reportIssueForm.message;
      const payload = {
        sender: this.userInfo?._id || "683fd5b24850fae097f99d37",
        metadata: {
          type: "fastforge_chat_option_based",
          project_name: "fastforge",
          option_type: "api_based",
          option_name: "my_order_issue",
          order_id: this.selectedOrderId,
          reportedToId: this.sellerDetails[0].id,
          assignToId: this.sellerDetails[0].id,
          loginUrl: window.location.origin,
          name,
          email,
          phone,
          description,
          subject: "Order Issues",
          authorization: token,
        },
        message: "",
      };
      try {
        const response = await this.$store.dispatch(
          "chatbot/fetchOptionsAction",
          payload,
        );
        const data = await response.data;
        const msg = data[0]?.custom?.message || "Thank you for contacting us!";
        const options = data[0]?.custom?.options || [];
        const formattedMsg = msg.replace(
          /\[([^\]]+)\]\(([^)]+)\)/g,
          '<a href="$2" target="_blank" rel="noopener noreferrer">$1</a>',
        );

        this.addMessage(
          formattedMsg,
          // msg,
          "bot",
          options.map((opt) => ({
            title: opt.message,
            payload: JSON.stringify({
              optionType: opt.nextParent,
              nextParent: opt.optionType,
              url: opt.url,
            }),
          })),
        );
        this.contactForm = { message: "" };
      } catch {
        this.addMessage(
          "Sorry, there was a problem submitting your request.",
          "bot",
        );
      }
    },
    async submitOrderNotFoundForm() {
      console.log(this.selectedOrderId, "this.selectedOrderId");
      const token = localStorage.getItem(
        `${process.env.VUE_APP_TENANT}:access_token`,
      );
      this.sellerDetails = this.sellerDetail(this.$store.state);
      const name =
        `${this.userInfo.name?.first || ""} ${this.userInfo.name?.last || ""}`.trim();
      const email = this.userInfo.authentication.email;
      const phone = this.userInfo.authentication.phone;
      const description = this.paymentIssueForm.message;
      const payload = {
        sender: this.userInfo?._id || "683fd5b24850fae097f99d37",
        metadata: {
          type: "fastforge_chat_option_based",
          project_name: "fastforge",
          option_type: "api_based",
          option_name: "my_payment_issue",
          reportedToId: this.sellerDetails[0].id,
          assignToId: this.sellerDetails[0].id,
          loginUrl: window.location.origin,
          name,
          email,
          phone,
          description,
          subject: "Payment Issues",
          authorization: token,
        },
        message: "",
      };
      try {
        const response = await this.$store.dispatch(
          "chatbot/fetchOptionsAction",
          payload,
        );
        const data = await response.data;
        const msg = data[0]?.custom?.message || "Thank you for contacting us!";
        const options = data[0]?.custom?.options || [];
        const formattedMsg = msg.replace(
          /\[([^\]]+)\]\(([^)]+)\)/g,
          '<a href="$2" target="_blank" rel="noopener noreferrer">$1</a>',
        );

        this.addMessage(
          formattedMsg,
          // msg,
          "bot",
          options.map((opt) => ({
            title: opt.message,
            payload: JSON.stringify({
              optionType: opt.nextParent,
              nextParent: opt.optionType,
              url: opt.url,
            }),
          })),
        );
        this.contactForm = { message: "" };
      } catch {
        this.addMessage(
          "Sorry, there was a problem submitting your request.",
          "bot",
        );
      }
    },
    async cancelOrderDetails(item) {
      await this.$swal({
        title: "Are you sure?",
        text: "Do you really want to cancel this order?",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, cancel it!",
        cancelButtonText: "No, keep it",
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
      }).then(async (result) => {
        if (result.value) {
          await this.fetchRootOptions(item.nextParent, item.optionType, {
            order_id: item._id,
            orderId: item.orderId,
          });
        }
      });
    },
    handleOrderRowClick(item, scenarioType = "") {
      console.log("Clicked item:", item); // Add this
      this.selectedOrderId = item.orderId;
      if (scenarioType === "payment_issues") {
        this.selectedPaymentIssueOrder = item;
        this.selectedOrderId = item.orderId;
        this.paymentIssueForm = { message: "" };
        this.addPaymentIssueFormMessage();
        return;
      }
      if (this.currentOptionName === "cancel_my_order")
        this.cancelOrderDetails(item);
      else if (this.currentOptionName === "pending_payment_list")
        this.showpendingDetails(item);
      else this.showOrderDetails(item);
    },
    addPaymentIssueFormMessage(
      messageText = "Please describe your payment issue below:",
      option_name = "my_payment_issue",
    ) {
      this.messages.push({
        id: this.messages.length + 1,
        text: messageText,
        paymentIssueForm: true,
        option_name,
        time: this._getTime(),
        sender: "bot",
      });
    },
    addOrderNotFoundFormMessage(
      messageText = "Please describe your issue below:",
      option_name = "order_not_found",
    ) {
      this.messages.push({
        id: this.messages.length + 1,
        text: messageText,
        orderNotFoundForm: true,
        option_name,
        time: this._getTime(),
        sender: "bot",
      });
    },
    addReportIssueFormMessage(
      messageText = "Please provide details about the issue you want to report:",
      option_name = "report_issue",
    ) {
      this.messages.push({
        id: this.messages.length + 1,
        text: messageText,
        reportIssueForm: true,
        option_name,
        time: this._getTime(),
        sender: "bot",
      });
    },
    showOrderDetails(item) {
      return this.fetchRootOptions(item.nextParent, item.optionType, {
        order_id: item._id,
        orderId: item.orderId,
      });
    },
    showpendingDetails(item) {
      return this.fetchRootOptions(item.nextParent, item.optionType, {
        order_id: item._id,
        orderId: item.orderId,
      });
    },
    async submitContactForm() {
      const token = localStorage.getItem(
        `${process.env.VUE_APP_TENANT}:access_token`,
      );
      const name =
        `${this.userInfo.name?.first || ""} ${this.userInfo.name?.last || ""}`.trim();
      const email = this.userInfo.authentication.email;
      const phone = this.userInfo.authentication.phone;
      const topic = this.previousOptionName;
      const payload = {
        sender: this.userInfo?._id || "683fd5b24850fae097f99d37",
        metadata: {
          type: "fastforge_chat_option_based",
          project_name: "fastforge",
          option_type: "api_based",
          option_name: "contact_us",
          name,
          email,
          phone,
          topic,
          message: this.contactForm.message,
          authorization: token,
        },
        message: "",
      };
      try {
        const response = await this.$store.dispatch(
          "chatbot/fetchOptionsAction",
          payload,
        );
        const data = await response.data;
        const msg = data[0]?.custom?.message || "Thank you for contacting us!";
        const options = data[0]?.custom?.options || [];
        this.addMessage(
          msg,
          "bot",
          options.map((opt) => ({
            title: opt.message,
            payload: JSON.stringify({
              optionType: opt.nextParent,
              nextParent: opt.optionType,
              url: opt.url,
            }),
          })),
        );
        this.contactForm = { message: "" };
      } catch {
        this.addMessage(
          "Sorry, there was a problem submitting your request.",
          "bot",
        );
      }
    },
    async addWelcomeMessageWithTyping() {
      const userName = this.userInfo?.name?.first || "User";
      const isLoggedIn = this.$store.state["auth"]?.isLoggedin;
      let companyName = "Fastforge";
      this.isTyping = true;

      try {
        const tenantResp = await this.$store.dispatch(
          "home/fetchTenantDetails",
          process.env.VUE_APP_TENANT,
        );
        companyName = tenantResp?.data?.response?.company?.name || "Fastforge";
      } catch (error) {
        console.error("Failed to fetch tenant details:", error);
      }
      await new Promise((resolve) => {
        setTimeout(() => {
          if (isLoggedIn) {
            this.addMessage(
              `Hello ${userName}! Welcome to ${companyName} Help Centre. How can I help you today?`,
              "bot",
            );
          } else {
            this.addMessage(
              `Hello! It looks like you're not logged in. Please sign in to access the ${companyName} Help Centre and get support.`,
              "bot",
            );
          }
          this.isTyping = false;
          resolve();
        }, 1500);
      });

      if (isLoggedIn) {
        await this.fetchRootOptions();
      }
    },
    _getTime() {
      return new Date().toLocaleTimeString().slice(0, 5);
    },
  },
};
</script>

<style scoped>
.account-detail-container {
  margin-top: 10px;
  background: #f8f8f8;
  padding: 10px;
  border-radius: 6px;
}

.account-detail-container ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.account-detail-container li {
  margin-bottom: 5px;
}

.order-table-container {
  margin-top: 10px;
}

.order-table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 10px;
  font-size: 14px;
}

.order-table th,
.order-table td {
  border: 1px solid #ddd;
  padding: 8px;
}

.order-row {
  cursor: pointer;
  transition: background 0.2s;
}

.order-row:hover {
  background: #f5f5f5;
}

.product-details {
  margin-top: 10px;
  background: #f8f8f8;
  padding: 10px;
  border-radius: 6px;
}

.product-details ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.product-details li {
  margin-bottom: 5px;
}

.product-image {
  max-width: 90px;
  max-height: 90px;
  display: block;
  margin-bottom: 8px;
}

.contact-form-container {
  background: #fff;
  padding: 24px 16px;
  border-radius: 10px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.07);
  max-width: 400px;
  margin: 16px auto;
}

.contact-form-container form {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.contact-form-container label {
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 4px;
  color: #333;
}

.contact-form-container input,
.contact-form-container textarea {
  width: 100%;
  padding: 8px 10px;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  font-size: 15px;
  background: #fafbfc;
  transition: border 0.2s;
}

.contact-form-container input:focus,
.contact-form-container textarea:focus {
  border-color: #6c63ff;
  outline: none;
}

.contact-form-container textarea {
  min-height: 80px;
  resize: vertical;
}

.contact-form-container button[type="submit"] {
  background: #fff;
  color: #0076ff;
  border: 1px solid var(--primarycolor);
  padding: 10px 20px;
  border-radius: 8px;
  font-weight: 500;
  font-size: 14px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  width: fit-content;
  max-width: 90%;
  text-align: start;
  text-transform: capitalize;
  transition:
    background 0.2s ease,
    color 0.2s ease;
}

.contact-form-container button[type="submit"]:hover {
  background: var(--primarycolor);
  color: white;
  transform: translateY(-1px);
}

/* Fixed chat icon */
.tap-top4 {
  width: 60px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  position: fixed;
  bottom: 65px;
  right: 30px;
  z-index: 8;
  background: linear-gradient(var(--primarycolor), var(--darkcolor));
  color: white;
  text-align: center;
  box-shadow: 0 8px 15px rgba(0, 0, 0, 0.3);
  cursor: pointer;
  transition: transform 0.2s ease-in-out;
}

.tap-top4:hover {
  transform: scale(1.1);
}

.chatbot-logo {
  width: 50px;
  height: 50px;
}

.chatbot-logo-small {
  height: 25px;
  width: 25px;
  margin-right: 10px;
}

/* Chat Popup */
.chat-popup {
  position: fixed;
  bottom: 80px;
  right: 20px;
  width: 380px;
  background: white;
  border-radius: 15px;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.2);
  z-index: 999;
  display: flex;
  flex-direction: column;
  max-height: 500px;
  overflow: hidden;
  transition: all 0.3s ease-in-out;
  animation: bounceIn 0.6s ease-out;
}

@media (max-width: 768px) {
  .chat-popup {
    width: 90%;
    right: 5%;
    bottom: 50px;
    max-height: 450px;
  }
}

/* Chat Header */
.chat-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px;
  background: linear-gradient(var(--primarycolor), var(--darkcolor));
  color: white;
  border-top-left-radius: 15px;
  border-top-right-radius: 15px;
}

.chat-title {
  display: flex;
  align-items: center;
  font-size: 18px;
}

.chat-status {
  font-size: 14px;
  font-weight: 100;
  position: relative;
  top: 19px;
  right: 140px;
}

.online-dot {
  width: 10px;
  height: 10px;
  margin-right: 8px;
  background-color: #28a745;
  border-radius: 50%;
  display: inline-block;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.3);
}

.close-button {
  cursor: pointer;
}

/* Chat Messages */
.chat-messages {
  flex-grow: 1;
  padding: 15px;
  background-color: #f1f1f1;
  overflow-y: auto;
}

.message {
  display: flex;
  align-items: flex-end;
  margin-bottom: 10px;
}

.user {
  flex-direction: row-reverse;
}

.user .img,
.bot .img {
  margin: 0 10px;
  /* Apply margin on both sides */
}

.user .bubble,
.bot .bubble {
  background: #ffffff;
  color: #333;
  padding: 12px 16px;
  border-radius: 12px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  border: 1px solid #ddd;
}

.msg,
.msg p {
  margin: 0;
  padding: 0;
  line-height: 1.4;
  white-space: pre-line;
}

.img {
  margin-right: 10px;
}

.avatar {
  height: 45px;
  width: 45px;
  background: linear-gradient(var(--primarycolor), var(--darkcolor));
  border-radius: 50%;
  padding: 4px;
}

/* Button Styling */
.button-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 12px;
  align-items: start;
  flex-wrap: wrap;
}

.response-button {
  background: #fff;
  color: #0076ff;
  border: 1px solid var(--primarycolor);
  padding: 10px 20px;
  border-radius: 8px;
  font-weight: 500;
  font-size: 14px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  width: fit-content;
  max-width: 90%;
  text-align: start;
  text-transform: capitalize;
  transition:
    background 0.2s ease,
    color 0.2s ease;
}

.response-button:hover {
  background: var(--primarycolor);
  color: white;
  transform: translateY(-1px);
}

/* Chat Input */
.chat-input {
  display: flex;
  align-items: center;
  padding: 15px;
  background-color: #fff;
  border-top: 1px solid #ccc;
}

.chat-input input {
  flex-grow: 1;
  border: none;
  border-radius: 30px;
  padding: 10px 15px;
  margin-right: 10px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}

.chat-input button {
  background: none;
  cursor: pointer;
  font-size: 20px;
}

button:disabled {
  color: #000;
  cursor: not-allowed;
}

/* Typing Indicator */
.typing-indicator {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 12px;
  background: #f1f1f7;
  border-radius: 20px;
  width: fit-content;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}

.typing-indicator .dot {
  width: 10px;
  height: 10px;
  background-color: #6c63ff;
  border-radius: 50%;
  opacity: 0.5;
  animation: typing-bounce 1s infinite alternate;
}

.typing-indicator .dot:nth-child(2) {
  animation-delay: 0.2s;
}

.typing-indicator .dot:nth-child(3) {
  animation-delay: 0.4s;
}

@keyframes typing-bounce {
  0% {
    opacity: 0.5;
    transform: translateY(0);
  }

  50% {
    opacity: 1;
    transform: translateY(-6px);
  }

  100% {
    opacity: 0.5;
    transform: translateY(0);
  }
}

.closing {
  animation: bounceOut 0.6s ease-out forwards;
}

@keyframes bounceIn {
  0% {
    opacity: 0;
    transform: translateY(100%);
  }

  70% {
    transform: translateY(-10px);
  }

  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes bounceOut {
  0% {
    opacity: 1;
    transform: translateY(0);
  }

  30% {
    transform: translateY(-10px);
  }

  100% {
    opacity: 0;
    transform: translateY(100%);
  }
}

.order-detail-container {
  margin-top: 10px;
  background: #f8f8f8;
  padding: 10px;
  border-radius: 6px;
}

.order-detail-container ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.order-detail-container li {
  margin-bottom: 5px;
}

.product-image {
  max-width: 90px;
  max-height: 90px;
  display: block;
  margin-top: 8px;
}
</style>
